<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="page">
	<div class="page-header">
		<div class="back">
			<globalictcc-button
				label="Back to toolbox"
				[textOnly]="true"
				iconName="arrow-left"
				(handleClick)="onGoBack()"
			/>
		</div>

		<div class="page-title">
			<span class="page-name">Calculator</span>

			<span class="page-description">
				Calculate your total environmental impact by adding your components details
			</span>
		</div>
	</div>

	<section class="sub-section">
		<div class="sub-section-header">
			<span class="sub-section-title">1. Choose your resource type</span>

			<span class="sub-section-description">
				Select the resource type to proceed with the detailed configuration.
			</span>
		</div>

		<form [formGroup]="resourceForm">
			<div class="form-container">
				<div class="adjacent-inputs">
					<globalictcc-dropdown
						label="Resource type"
						formControlName="resourceType"
						[options]="resourceTypes"
					/>

					<globalictcc-button
						label="Apply"
						(handleClick)="onResourceApply()"
						[disabled]="resourceForm.invalid"
					/>
				</div>
			</div>
		</form>
	</section>

	<div><router-outlet /></div>

	@if (calculation$ | async; as calculationKpis) {
		<div class="cards">
			<div class="card">
				<span class="icon-radar-weather"></span>

				<span class="card-title">Carbon footprint</span>

				<span class="card-value">
					<span class="card-value-big">
						{{ calculationKpis.totalCo2 | maxDecimals: 2 }}
					</span>
					gCO2e
				</span>
			</div>

			@if (resourceForm.controls.resourceType.value === paths.SOFTWARE_ASSETS) {
				<div class="card">
					<span class="icon-charge-slow"></span>

					<span class="card-title">Power consumption</span>

					<span class="card-value">
						<span class="card-value-big">
							{{ calculationKpis.totalEnergy | maxDecimals: 2 }}
						</span>
						kWh
					</span>
				</div>
			}
		</div>

		<div class="other-terms">
			<span class="other-terms-title">In other terms</span>

			<span class="other-terms-description">Your impact beyond industry metrics</span>
		</div>

		<div class="cards">
			<div class="card no-bg">
				<span class="icon-tree"></span>

				<span class="card-title">
					{{ calculationKpis.equivalentTrees | maxDecimals: 2 }} Trees
				</span>

				<span class="card-description">
					Equal to CO2 absorbed by
					{{ calculationKpis.equivalentTrees | maxDecimals: 2 }} trees in a month
				</span>
			</div>

			<div class="card no-bg">
				<span class="icon-car"></span>

				<span class="card-title">
					{{ calculationKpis.equivalentAuto | maxDecimals: 2 }} Km drive
				</span>

				<span class="card-description">
					Equal to {{ calculationKpis.equivalentAuto | maxDecimals: 2 }} Km traveled by
					car
				</span>
			</div>

			<div class="card no-bg">
				<span class="icon-plane-private"></span>

				<span class="card-title">
					{{ calculationKpis.equivalentFlight | maxDecimals: 2 }} Km flight
				</span>

				<span class="card-description">
					Equal to
					{{ calculationKpis.equivalentFlight | maxDecimals: 2 }} short-medium haul flight
					per passenger
				</span>
			</div>
		</div>

		@if (resourceForm.controls.resourceType.value === paths.HARDWARE_ASSETS) {
			<globalictcc-button
				label="Add the list to the hardware page"
				(handleClick)="onSaveCalculation()"
			/>
		}
	}
</section>
